import type { LanguageCode } from './types';
import { JsonLocalizationService } from './JsonLocalizationService';

const localeModules = import.meta.glob('./locales/*/*.json', { eager: true }) as Record<
  string,
  { default: Record<string, string> }
>;

function readLocaleDictionary(module: unknown): Record<string, string> {
  if (module && typeof module === 'object' && 'default' in module) {
    const dict = (module as { default: unknown }).default;
    if (dict && typeof dict === 'object') return dict as Record<string, string>;
  }
  if (module && typeof module === 'object') return module as Record<string, string>;
  return {};
}

/**
 * JSON dosyalarını JsonLocalizationService'e yükler.
 * Yol: src/localization/locales/{lang}/{namespace}.json
 */
export function loadJsonLocalizationDictionaries(
  service: JsonLocalizationService,
): void {
  for (const [path, module] of Object.entries(localeModules)) {
    const match = path.match(/locales\/([^/]+)\/([^/]+)\.json$/);
    if (!match) continue;
    const [, lang] = match;
    if (lang !== 'tr' && lang !== 'en') continue;
    service.load(lang as LanguageCode, readLocaleDictionary(module));
  }
}
